<template>
  <div>
    <img :src="video.image_url" :alt="video.title" class="rounded-t-lg" />
  </div>
</template>

<script>
import videoListItemContentMixin from '@/mixins/videoListItemContentMixin'

export default {
  mixins: [videoListItemContentMixin],
}
</script>
